const buildPromoMessage = (
  discountedPrice,
  discountBenefitValue,
  formatTranslation,
  discountCode,
) => {
  const withCodeLabel = discountCode
    ? `${formatTranslation("generic_with_code")}: ${discountCode}`
    : formatTranslation("generic_with_code");

  return [discountedPrice, discountBenefitValue, withCodeLabel]
    .filter(Boolean)
    .join(" ");
};

const getPriceInfo = ({
  price,
  reducedPrice,
  isOutlet,
  hasMultiplePrices,
  formatTranslation,
  euOmnibusEnabled,
  isPromotionalDiscount,
  discountCode,
  markdownPrice,
  discountBenefitValue,
  discountedPrice,
}) => {
  const fromLabel = hasMultiplePrices
    ? `${formatTranslation("plp_web_product_tile_price_from")} `
    : "";
  const priceLabel = formatTranslation("plp_web_a11y_price");
  const currentPriceLabel = formatTranslation("generic_current_price");

  if (euOmnibusEnabled) {
    return `${fromLabel}; ${currentPriceLabel}: ${
      reducedPrice ? reducedPrice : price
    }`;
  }

  if (isPromotionalDiscount && discountBenefitValue) {
    const previousPriceLabel = formatTranslation("plp_web_a11y_original_price");
    const promoMessage = buildPromoMessage(
      discountedPrice,
      discountBenefitValue,
      formatTranslation,
      discountCode,
    );

    if (markdownPrice) {
      const markdownPriceLabel = formatTranslation(
        "plp_web_a11y_original_price",
      );

      return `${markdownPriceLabel}: ${markdownPrice}, ${currentPriceLabel}: ${promoMessage}`;
    }

    return `${previousPriceLabel}: ${price}, ${currentPriceLabel}: ${promoMessage}`;
  }

  if (reducedPrice) {
    const previousPriceLabel = isOutlet
      ? formatTranslation("generic_price_rrp")
      : formatTranslation("plp_web_a11y_original_price");

    return `${previousPriceLabel}: ${price}, ${currentPriceLabel}: ${fromLabel}${reducedPrice}`;
  }

  return `${priceLabel}: ${fromLabel}${price}`;
};

export default getPriceInfo;
